import { useEffect, useState, useContext } from "react";
import { Loader2, Instagram, Plus, AlertTriangle } from "lucide-react";
import { listContas } from "./services/instagramApi";
import ConnectForm from "./components/ConnectForm";
import ContaCard from "./components/ContaCard";
import { SidebarContext } from "../../shared/context/SidebarContext";

export default function InstagramOficial() {
  const { isOpen } = useContext(SidebarContext);
  const [contas, setContas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState(false);
  const [conectandoOutra, setConectandoOutra] = useState(false);

  async function carregar() {
    setLoading(true);
    setErro(false);
    try {
      const data = await listContas();
      setContas(data);
    } catch (_) {
      setContas([]);
      setErro(true);
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    carregar();
  }, []);

  function handleSuccess() {
    setConectandoOutra(false);
    carregar();
  }

  const temContas = contas.length > 0;

  return (
    <div className="min-h-screen text-ink-1 flex relative z-0">
      <div
        className={`transition-all duration-300 ease-out-expo ${
          isOpen ? "lg:ml-64" : "sm:ml-16"
        } w-full max-w-full mb-16 sm:mb-0`}
      >
        <div className="px-5 sm:px-8 pt-8 pb-12 max-w-[1600px] mx-auto">

          <header className="mb-8 animate-fade-in">
            <div className="space-y-1">
              <span className="chip-brand">
                <Instagram className="h-3 w-3" />
                Meta Graph API
              </span>
              <h1 className="display-2 flex items-center gap-3 mt-2">
                Instagram
                <Instagram className="h-7 w-7 text-brand-400" strokeWidth={2.2} />
              </h1>
              <p className="text-ink-3 text-sm max-w-2xl">
                Conecte sua conta Instagram Business via System User Token para receber comentários e
                mensagens diretas direto no Metriqa.
              </p>
            </div>
          </header>

          {loading ? (
            <div className="surface-card p-12 grid place-items-center">
              <Loader2 className="h-7 w-7 animate-spin text-brand-400 mb-3" />
              <p className="text-sm text-ink-4">Carregando contas...</p>
            </div>
          ) : erro ? (
            <div className="surface-card p-6 max-w-2xl flex items-start gap-3">
              <AlertTriangle className="h-5 w-5 text-danger-400 flex-shrink-0 mt-0.5" />
              <div>
                <p className="text-sm text-ink-1 font-medium mb-1">Não foi possível carregar as contas</p>
                <p className="text-sm text-ink-3 mb-3">Tente novamente em instantes.</p>
                <button onClick={carregar} className="btn-ghost">
                  Tentar de novo
                </button>
              </div>
            </div>
          ) : !temContas ? (
            <ConnectForm onSuccess={handleSuccess} />
          ) : (
            <div className="space-y-6 animate-slide-up">
              <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
                {contas.map((conta) => (
                  <ContaCard key={conta.id} conta={conta} onDisconnected={carregar} />
                ))}
              </div>

              {conectandoOutra ? (
                <ConnectForm onSuccess={handleSuccess} />
              ) : (
                <button onClick={() => setConectandoOutra(true)} className="btn-ghost">
                  <Plus className="h-4 w-4" /> Conectar outra conta
                </button>
              )}
            </div>
          )}

        </div>
      </div>
    </div>
  );
}
